// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ContactIdMappingListPagingResultModel from '../../model/contact-id-mapping-list-paging-result-model';
import ContactIdMappingListPagingResultDTO from '../dto/contact-id-mapping-list-paging-result-dto';
import ContactIdMappingListModel from '../../model/contact-id-mapping-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ContactIdMappingListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ContactIdMappingListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ContactIdMappingListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  'items'?: ContactIdMappingListModel[];
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  */
  'paginationData'?: PaginationDataModel;

  static toModel(dto: DeepPartial<ContactIdMappingListPagingResultDTO>): ContactIdMappingListPagingResultModel;
  static toModel(dto: DeepPartial<ContactIdMappingListPagingResultDTO> | undefined | null): ContactIdMappingListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<ContactIdMappingListPagingResultDTO> | undefined | null): ContactIdMappingListPagingResultModel | undefined {
    return dto ? new ContactIdMappingListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ContactIdMappingListPagingResultModel> | ContactIdMappingListPagingResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
      'paginationData': unwrapped.paginationData,
    } as ContactIdMappingListPagingResultDTO;
  }
}
